exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-action-select{display:flex;justify-content:space-between;align-items:center;padding:1.375rem 0;border-bottom:.0625rem dashed #b0b8bf;line-height:1.25rem;color:#516a7d;font-size:.875rem}.form-action-select .icon.calendar,.form-action-select .icon.roles,.form-action-select .icon.settings{height:1.25rem;margin-right:.25rem;vertical-align:middle;transform:translateY(-2px)}.form-action-select .icon.calendar path,.form-action-select .icon.roles path,.form-action-select .icon.settings path{fill:#516a7d}.form-action-select .icon.carrot-right{height:.625rem;margin-left:.25rem;vertical-align:middle;transform:translateY(-2px)}.form-action-select .icon.carrot-right path{fill:#2a3640}.form-action-select__action-menu{position:relative}.form-action-select__trigger{text-transform:capitalize;border:0;background:transparent;padding:0;font-family:avenir,sans-serif;color:#516a7d}.form-action-select__trigger:active,.form-action-select__trigger:focus{outline:0}.form-action-select .action-menu{top:-10rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FormActionSelect/FormActionSelect.scss
// module id = 675
// module chunks = 0